import React, { useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";

import UsersAdministrationPageView from "./UsersAdministrationPage.View";
import UsersAdministrationPageViewModel from "./UsersAdministrationPage.ViewModel";

const initUser = {
    id: "",
    firstName: "",
    lastName: "",
    preposition: "",
    role: 0,
    schoolId: "",
    softEmail: "",
    course: "",
    class: "",
    iddinkCode: "",
    email: "",
};

export function UsersAdministrationPage() {
    const tableTemplateRef = useRef(null);
    // @ts-ignore
    const userData = useSelector((state) => state.user.credentials);

    //#region States
    const [showEditRolesModal, setShowEditRolesModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showManageSchoolsModal, setShowManageSchoolsModal] = useState(false);
    const [activeUser, setActiveUser] = useState(initUser);
    const [userIsEnabled, setUserIsEnabled] = useState(null);
    const [userNotAllowed, setUserNotAllowed] = useState(false);
    const [schoolList, setSchoolList] = useState([]);
    const [schoolSelected, setSchoolSelected] = useState();
    const [showSchoolSelectModal, setShowSchoolSelectModal] = useState(false);
    //#endregion

    const _viewModel = UsersAdministrationPageViewModel({ tableTemplateRef, setSchoolList });

    useEffect(() => {
        _viewModel.getSchoolList();
    }, []);

    //#region Handlers
    function handleTableTemplateDelete(row) {
        return _viewModel.deleteUser(row.id);
    }

    function handleTableTemplateGetItems() {
        return _viewModel.tableTemplateGetItems();
    }

    async function handleActiveUserAction(row) {
        return _viewModel.enableUser(row);
    }

    function handleUserBlockAction(row) {
        return _viewModel.blockUser(row);
    }

    function handleEditRolesAction(row) {
        setActiveUser(row);
        setShowEditRolesModal(true);
    }

    function handleEditUserAction(row) {
        setActiveUser(row);
        setShowEditModal(true);
    }

    /**
     * Handles the change event for filtering user state.
     *
     * @param {React.ChangeEvent<HTMLSelectElement>} event - The event object triggered by the change.
     */
    function handleFilterUserStateChange(event) {
        const value = event.target.value;
        console.log(value);
        if (value === "0") {
            setUserIsEnabled(null);
            setUserNotAllowed(false);
        } else if (value === "1") {
            setUserIsEnabled(true);
            setUserNotAllowed(false);
        } else if (value === "2") {
            setUserIsEnabled(false);
            setUserNotAllowed(false);
        } else if (value === "3") {
            setUserIsEnabled(false);
            setUserNotAllowed(true);
        }
    }

    function handleHideEditModal() {
        setShowEditModal(false);
    }

    function handleHideEditRolesModal() {
        setShowEditRolesModal(false);
    }

    function handleManageSchoolsAction(row) {
        setActiveUser(row);
        setShowManageSchoolsModal(true);
    }

    function handleManageSchoolsModalHide() {
        setShowManageSchoolsModal(false);
    }

    function handleTableTemplateClearExtraFiltersParams() {
        // @ts-ignore
        setUserIsEnabled("");
    }

    async function handleFilterSelectSchoolClick() {
        setShowSchoolSelectModal(true);
    }

    function handleSchoolSelectModalHide() {
        setShowSchoolSelectModal(false);
    }

    function handleSchoolSelectedClearClick() {
        console.log("clear");
        setSchoolSelected(null);
    }

    //#endregion

    return (
        <UsersAdministrationPageView
            userData={userData}
            activeUser={activeUser}
            onTableTemplateDelete={handleTableTemplateDelete}
            showEditModal={showEditModal}
            userIsEnabled={userIsEnabled}
            userNotAllowed={userNotAllowed}
            showEditRolesModal={showEditRolesModal}
            showManageSchoolsModal={showManageSchoolsModal}
            tableTemplateRef={tableTemplateRef}
            schoolList={schoolList}
            schoolSelected={schoolSelected}
            setSchoolSelected={setSchoolSelected}
            showSchoolSelectModal={showSchoolSelectModal}
            onActiveUserAction={handleActiveUserAction}
            onEditRolesAction={handleEditRolesAction}
            onEditUserAction={handleEditUserAction}
            onManageSchoolsAction={handleManageSchoolsAction}
            onUserBlockAction={handleUserBlockAction}
            onEditModalSubmit={handleTableTemplateGetItems}
            onEditRolesModalSubmit={handleTableTemplateGetItems}
            onFilterUserStateChange={handleFilterUserStateChange}
            onHideEditModal={handleHideEditModal}
            onHideEditRolesModal={handleHideEditRolesModal}
            onManageSchoolsModalHide={handleManageSchoolsModalHide}
            onManageSchoolsModalSubmit={handleTableTemplateGetItems}
            onTableTemplateClearExtraFiltersParams={handleTableTemplateClearExtraFiltersParams}
            onFilterSelectSchoolClick={handleFilterSelectSchoolClick}
            onSchoolSelectModalHide={handleSchoolSelectModalHide}
            onSchoolSelectedClearClick={handleSchoolSelectedClearClick}
        />
    );
}
